(function () {
  'use strict';

  function initCareers(root) {
    if (!root || root.dataset.careersReady === 'true') return;
    root.dataset.careersReady = 'true';

    var roles = Array.prototype.slice.call(root.querySelectorAll('[data-careers-role]'));
    var jump = root.querySelector('[data-careers-jump]');

    function resetLongDetail(role) {
      var detail = role.querySelector('[data-careers-detail]');
      var toggle = role.querySelector('[data-careers-detail-toggle]');
      if (!detail || !toggle) return;
      detail.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.querySelector('span').textContent = toggle.dataset.openLabel;
      toggle.classList.remove('is-expanded');
    }

    roles.forEach(function (role) {
      var summary = role.querySelector('summary');
      if (summary) {
        summary.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          role.open = !role.open;
        });
      }

      role.addEventListener('toggle', function () {
        if (role.open) {
          roles.forEach(function (other) {
            if (other !== role) other.open = false;
          });
        } else {
          resetLongDetail(role);
        }
      });

      role.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        var detail = role.querySelector('[data-careers-detail]');
        var toggle = role.querySelector('[data-careers-detail-toggle]');
        if (detail && !detail.hidden) {
          event.preventDefault();
          resetLongDetail(role);
          toggle.focus();
        } else if (role.open) {
          event.preventDefault();
          role.open = false;
          role.querySelector('summary').focus();
        }
      });

      var detailToggle = role.querySelector('[data-careers-detail-toggle]');
      if (detailToggle) {
        detailToggle.addEventListener('click', function () {
          var detail = role.querySelector('[data-careers-detail]');
          var expanded = detailToggle.getAttribute('aria-expanded') === 'true';
          detail.hidden = expanded;
          detailToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          detailToggle.querySelector('span').textContent = expanded ? detailToggle.dataset.openLabel : detailToggle.dataset.closeLabel;
          detailToggle.classList.toggle('is-expanded', !expanded);
        });
      }
    });

    if (jump) {
      jump.addEventListener('click', function (event) {
        var target = root.querySelector(jump.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
        window.history.replaceState(null, '', '#open-roles');
      });
    }
  }

  function boot() {
    initCareers(document.querySelector('[data-careers-redesign]'));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
